<script setup lang="ts">
  import Typography from '../Typography/Typography.vue'
  import type { BadgeProps } from './types'

  const props = withDefaults(defineProps<BadgeProps>(), {
    tone: 'blue',
    variant: 'pill',
    label: '',
  })
</script>
<template>
  <span
    class="inline-flex h-6 items-center justify-center rounded-full align-middle"
    :class="[
      {
        'bg-content-negative': tone === 'red',
        'bg-[#121721]': tone === 'dark-blue',
        'bg-action-primary-default': tone !== 'red' && tone !== 'dark-blue',
        'px-3 min-w-[32px]': variant === 'pill' && tone === 'dark-blue',
        'px-2 min-w-[32px]': variant === 'pill' && tone !== 'dark-blue',
        'w-6 min-w-[24px] px-0': variant !== 'pill',
      },
    ]"
  >
    <Typography
      variant="text-xs"
      weight="font-semibold"
      :color="
        tone === 'dark-blue' ? 'text-white' : 'text-content-inverted-primary'
      "
      class="leading-[24px]"
    >
      <slot>{{ props.label }}</slot>
    </Typography>
  </span>
</template>
